<h2 mat-dialog-title>Tyler Smart Meter Notification Type</h2>

<mat-dialog-content>
  <form [formGroup]="formGroup">
    <b>Notify Account Holder</b>
    <div class="checkboxPadding" fxLayout="column">
      @if (email) {
        <lgd-checkbox controlName="email" [label]="emailLabel">
        </lgd-checkbox>
      }

      @if (sms) {
        <lgd-checkbox controlName="sms" [label]="smsLabel">
        </lgd-checkbox>
      }

      @if (phone) {
        <lgd-checkbox controlName="phone" [label]="phoneLabel">
        </lgd-checkbox>
      }

      @if (noContactInformation) {
        <div>
          No notification will be sent. Email address and phone number were not provided.
        </div>
      }
    </div>

    <b>Notify Landlord</b>
    <div class="checkboxPadding" fxLayout="column">
      @if (landlordEmail) {
        <lgd-checkbox controlName="landlordEmail" [label]="landlordEmailLabel">
        </lgd-checkbox>
      }

      @if (landlordSms) {
        <lgd-checkbox controlName="landlordSms" [label]="landlordSmsLabel">
        </lgd-checkbox>
      }

      @if (landlordPhone) {
        <lgd-checkbox controlName="landlordPhone" [label]="landlordPhoneLabel">
        </lgd-checkbox>
      }

      @if (noLandLordContactInformation) {
        <div>
          Landlord notification settings not found.
        </div>
      }
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
  <button mat-button color="primary" (click)="sendNotification()">Send Notification</button>

  <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
</mat-dialog-actions>